import { atom } from "jotai";
export const isFormAtom = atom({isForm: false, id: ''});
export const fieldsDetail = atom([]);